import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-style',
  templateUrl: './icon-style.component.html',
  styleUrls: ['./icon-style.component.sass']
})
export class IconStyleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
